import React from "react";

export const EmailIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="18"
    height="14"
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M19 0.6875H1C0.850816 0.6875 0.707742 0.746763 0.602252 0.852252C0.496763 0.957742 0.4375 1.10082 0.4375 1.25V14C0.4375 14.3481 0.575781 14.6819 0.821922 14.9281C1.06806 15.1742 1.4019 15.3125 1.75 15.3125H18.25C18.5981 15.3125 18.9319 15.1742 19.1781 14.9281C19.4242 14.6819 19.5625 14.3481 19.5625 14V1.25C19.5625 1.10082 19.5032 0.957742 19.3977 0.852252C19.2923 0.746763 19.1492 0.6875 19 0.6875ZM10 8.73688L2.44562 1.8125H17.5544L10 8.73688ZM7.53156 8L1.5625 13.4713V2.52875L7.53156 8ZM8.36406 8.76312L9.625 9.91438C9.72869 10.0092 9.86415 10.0619 10.0047 10.0619C10.1452 10.0619 10.2807 10.0092 10.3844 9.91438L11.6406 8.76312L17.5544 14.1875H2.44656L8.36406 8.76312ZM12.4684 8L18.4375 2.52875V13.4713L12.4684 8Z"
      fill="currentColor"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/ActionBar/EmailIcon.tsx